
const timeout = 350
const historyExitingEventType = `history::exiting`

export { historyExitingEventType, timeout }
